import TinyColor2 from 'tinycolor2';

const wrap = (color) => (color?.getBrightness ? color : new TinyColor2(color));

export default (backgroundColor, color, text) => {
    const factor1 = wrap(backgroundColor).getBrightness();
    const factor2 = wrap(color).getBrightness();

    if (Math.abs(factor1 - factor2) < 30) {
        return {
            backgroundColor,
            color: wrap(text)
                .setAlpha(0.9)
                .toRgbString(),
            border: color,
        };
    }

    return {
        backgroundColor,
        color,
        border: color,
    };
};
